<template>
    <TsRow :is-multiline="isMobile" class="gap-4">
      <TsColumn appendClass="is-4 max-md:is-12" v-for="el in data">
        <TsCard no-shadow  >
            <template #content>
                <TsRow>
                    <TsColumn class="is-3 max-md:is-4">
                        <TsImage class="w-full" v-if="el.image" :src="el.image" loading="lazy"/>
                    </TsColumn>
                    <TsColumn>
                        <TsTypography append-class="mb-2">
                            <span v-html="el.desc"></span>
                        </TsTypography>
                        <TsButton :label="el.buttonLabel" />
                    </TsColumn>
                </TsRow>
            </template>
        </TsCard>
      </TsColumn>
    </TsRow>
</template>

<script setup lang="ts">
const { isMobile } = useDevice();

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

type Data = {
    key: number;
    desc: string;
    image: string;
    buttonLabel: string;
}

type Props = {
    data?: Data[];
}

const props = withDefaults(defineProps<Props>(), {
    data: () => [
        {
            image: '/images/catalogueFree.svg',
            desc: 'Collect it for <strong>free</strong> in one of our stores',
            key: 1, 
            buttonLabel: 'At Store'
        },
        {
            image: '/images/catalogueOrder.svg',
            desc: 'Order it in just a <strong>few</strong> clicks!',
            key: 2, 
            buttonLabel: 'Order Offline'
        },
    ]
});
</script>